import { render, staticRenderFns } from "./FieldTagChainDialog.vue?vue&type=template&id=1217f397&scoped=true"
import script from "./FieldTagChainDialog.vue?vue&type=script&lang=js"
export * from "./FieldTagChainDialog.vue?vue&type=script&lang=js"
import style0 from "./FieldTagChainDialog.vue?vue&type=style&index=0&id=1217f397&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1217f397",
  null
  
)

export default component.exports